// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3MultiChoiceOptionContext$LiteracyplanetTupperware from "./V3MultiChoiceOptionContext.res.mjs";

function PilotMultiChoiceOptionContainer$Radio(props) {
  var match = Curry._1(V3MultiChoiceOptionContext$LiteracyplanetTupperware.use, undefined);
  var marked = match.marked;
  var selected = match.selected;
  var onClickOption = match.onClickOption;
  var tmp;
  if (selected) {
    switch (marked) {
      case "Correct" :
          tmp = React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpTick"
              });
          break;
      case "Wrong" :
          tmp = React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpCross"
              });
          break;
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  } else {
    switch (marked) {
      case "Wrong" :
          tmp = React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpTick"
              });
          break;
      case "Correct" :
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  }
  return React.createElement("div", {
              className: TailwindMerge.twMerge("PilotRadioButtonMultiChoice-Radio p-2 flex items-center gap-3 cursor-pointer select-none", selected && marked === "Correct" ? "bg-lpTickBackground" : "", selected && marked === "Wrong" ? "bg-lpCrossBackground" : ""),
              onClick: (function (param) {
                  Curry._1(onClickOption, undefined);
                })
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge("border-2 border-[#0c9ce5] w-5 h-5 rounded-full", selected ? "bg-[#0c9ce5]" : "")
                }), props.children, React.createElement("div", undefined, tmp));
}

var Radio = {
  make: PilotMultiChoiceOptionContainer$Radio
};

function PilotMultiChoiceOptionContainer(props) {
  return React.createElement(V3MultiChoiceOptionContext$LiteracyplanetTupperware.make, {
              group: props.group,
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: React.createElement(PilotMultiChoiceOptionContainer$Radio, {
                    children: props.children
                  })
            });
}

var make = PilotMultiChoiceOptionContainer;

export {
  Radio ,
  make ,
}
/* react Not a pure module */
